import { render, staticRenderFns } from "./IqSuggestOverlay.vue?vue&type=template&id=1371eb73&scoped=true"
import script from "./IqSuggestOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./IqSuggestOverlay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IqSuggestOverlay.vue?vue&type=style&index=0&id=1371eb73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371eb73",
  null
  
)

export default component.exports